module.exports = {"130973206":"新村回族乡","130973400":"南大港管理区","130973401":"国营中捷农场","130973402":"港城街道","130973403":"临港化工园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130973.json
// module id = 314
// module chunks = 0